// extracted by mini-css-extract-plugin
module.exports = {"webinars":"styles_webinars__2OV8L","items":"styles_items__3PdCu"};